import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import UploadDocument from "../summary/UploadDocument";
import { useDispatch } from "react-redux";
import { formatDateToShortMonth } from "../../utils/dateFormatUtils";
import { setFetchUserApplicationData } from "../../services/redux/slices/stepperDynamicFormSlice";
import { fetchUserApplicationsFormData } from "../../services/api/service/userApplicationService";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import {getCoApplicantList } from "../../utils/helpers";

const DocumentUploadPage = () => {
  const dispatch = useDispatch();
  const { applicationId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [tabsList, setTabsList] = useState<any>(null);
  const [coApplicantDetails, setCoApplicantDetails] = useState<any>(null);
  const [courseName, setCourseName] = useState("");
  const [applicationDetail, setApplicationDetail] = useState<any>(null);

  console.log("applicationId", applicationId);

  const getCoApplicationDetail = (fieldsList: any) => {
    const grouped: Record<string, any> = {};
    fieldsList?.map((item: any) => {
      const [key, value] = Object.entries(item)[0];
      const match = key.match(/CoApplicant(\d+)(.+)/);
      if (match) {
        const [, groupNumber, field] = match;
        if (!grouped[groupNumber]) grouped[groupNumber] = {};
        grouped[groupNumber][field] = value;
      }
      return null; // map needs to return something
    });
    return grouped;
  };

  const handleFetchApplicationDetail = async () => {
    setIsLoading(true);
    try {
      // Get authentication token from environment variables
      const token: any = process.env.REACT_APP_FETCH_TOKEN;

      // Fetch application form data using the application number
      const res: any = await fetchUserApplicationsFormData(
        token || "",
        applicationId || ""
      );

      console.log("handleFetchApplicationDetail res", res);

      if (res.status === 200) {
        setCourseName(
          res?.data?.applications?.[0]?.horizontalSteps?.[0]?.verticalSteps[1]?.fields?.find(
            (elem: any) => elem?.courseName
          )?.courseName
        );

        let loanAmount =
          res?.data?.applications?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[2]?.fields?.find(
            (elem: any) => elem?.loanAmount
          )?.loanAmount;
        const formattedLoanAmount = parseFloat(loanAmount);

        // Extract and structure application details from nested API response
        const dataJson: any = [
          {
            label: "Country",
            value:
              res?.data?.applications?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.find(
                (elem: any) => elem?.country
              )?.country,
          },
          {
            label: "University",
            value:
              res?.data?.applications?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.find(
                (elem: any) => elem?.university
              )?.university,
          },
          {
            label: "Institute",
            value:
              res?.data?.applications?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.find(
                (elem: any) => elem?.institute
              )?.institute,
          },
          {
            label: "Course Type",
            value:
              res?.data?.applications?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.find(
                (elem: any) => elem?.courseType
              )?.courseType,
          },
          {
            label: "Applied Loan Amount",
            value: !isNaN(formattedLoanAmount)
              ? formattedLoanAmount.toLocaleString()
              : "-",
          },
          {
            label: "Created On",
            value: formatDateToShortMonth(
              res?.data?.applications?.[0].createdAt
            ),
          },
          // {
          //   label: "Last Action Date",
          //   value: formatDateToShortMonth(
          //     res?.data?.applications?.[0].updatedAt
          //   ),
          // },
          // { label: "Completion Rate", value: "" }, // TODO: Add actual completion rate from API
        ];

        const applicationHorizontalSteps =
          res?.data?.applications?.[0]?.horizontalSteps || [];

        const fieldsList: any =getCoApplicantList(applicationHorizontalSteps);
        const coApplicantNumbers = Array.from(
          new Set(
            fieldsList
              ?.map((obj: any) =>
                Object.keys(obj || {})[0]?.match(/^basicCoApplicant(\d+)FirstName$/)?.[1]
              )
              .filter(Boolean)
              .map((num: string) => Number(num))
          )
        ).sort((a: any, b: any) => a - b);

        // Generate tab names for each co-applicant (Co-Applicant 1, Co-Applicant 2, etc.)
        const listOfCoApplicantTabName = Array.from(
          coApplicantNumbers,
          (coApplicantNumber) => `Co-Applicant ${coApplicantNumber}`
        );
        listOfCoApplicantTabName?.unshift("Applicant");

        setTabsList(listOfCoApplicantTabName);
        setApplicationDetail(dataJson);
        setCoApplicantDetails(getCoApplicationDetail(fieldsList));
        dispatch(
          setFetchUserApplicationData(
            res?.data?.applications?.[0]?.horizontalSteps
          )
        );
      }
    } catch (error) {
      // Log any errors that occur during the API call or data processing
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleFetchApplicationDetail();
  }, [applicationId]);

  console.log("tabsList", tabsList);
  console.log("coApplicantDetails", coApplicantDetails);

  return (
    <div
      className="card-contaner"
      style={{ minHeight: "100vh", marginBottom: "-20px" }}
    >
      <UploadDocument
        applicationId={applicationId}
        tabsList={tabsList}
        coApplicantDetails={coApplicantDetails}
      />
    </div>
  );
};

export default DocumentUploadPage;
